import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { StyledForm, StyledButton, StyledInput, StyledSelect } from '../../components';
export const RequestForm = ({ previewRef }) => {
    const [URL, setURL] = useState(`${process.env.REACT_APP_BACKEND_HOST}/users`);
    const [requestMethod, setRequestMethod] = useState('get');
    const [requestBody, setRequestBody] = useState({});
    const submitHandler = (event) => {
        event.preventDefault();
        const options = requestMethod !== 'get'
            ? {
                method: requestMethod.toUpperCase(),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify(requestBody),
            }
            : {};
        fetch(URL, options)
            .then(res => res.json())
            .then(result => {
            const text = JSON.stringify(result, null, 4);
            if (previewRef.current) {
                previewRef.current.innerText = text;
            }
        });
    };
    const urlChangeHandler = (event) => {
        setURL(event.currentTarget.value);
    };
    const methodChangeHandler = (event) => {
        setRequestMethod(event.currentTarget.value);
    };
    return (_jsxs(StyledForm, { style: { width: '40%' }, children: [_jsx(StyledInput, { name: "url", type: "text", placeholder: "URL", onChange: urlChangeHandler, value: URL, title: "You can find API documentation in server API.md file", required: true }), _jsxs(StyledSelect, { name: "method", onChange: methodChangeHandler, value: requestMethod, required: true, children: [_jsx("option", { value: "post", children: "POST" }), _jsx("option", { value: "get", children: "GET" }), _jsx("option", { value: "delete", children: "DELETE" }), _jsx("option", { value: "patch", children: "PATCH" })] }), requestMethod !== 'get' && requestMethod !== 'delete' ? (_jsxs(_Fragment, { children: [_jsx(StyledInput, { name: "name", type: "text", placeholder: "Name", title: `Name of ${requestMethod === 'POST' ? 'new' : requestMethod} element`, onChange: e => setRequestBody({ name: e.target.value }) }), _jsx(StyledInput, { name: "age", type: "number", placeholder: "Age", title: `Age of ${requestMethod === 'POST' ? 'new' : requestMethod} element`, onChange: e => setRequestBody(prev => (Object.assign(Object.assign({}, prev), { age: e.target.value }))) })] })) : (''), _jsx(StyledButton, { onClick: submitHandler, title: "Submit request", children: "Submit" })] }));
};
